// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"vs_a bhb_b"};